<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://semanggi.app/b2b/#docs" target="_blank">
            Documentation</a>
          </li>
          <li>
            <a href="https://semanggi.app/b2b/#support" target="_blank">
            Support</a>
          </li>
          <li>
            <a href="https://semanggi.app/" target="_blank">
            Public App</a>
          </li>
          <li>
            <a href="https://semanggi.app/#team" target="_blank">
              About Us
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://semanggi.app/" target="_blank"
          >SEAPP!!!</a
        >, made for your <i class="fa fa-heart heart"> with our competitive physical activity.</i>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
